var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.tabsList),function(item){return _c('div',{key:item.id,staticClass:"tab"},[_c('span',[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"underline"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }